
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const thermite: Operator = {
	id: 'thermite',
	name: 'Thermite',
	role: 'Attacker',
	org: 'FBI SWAT',
	squad: 'REDHAMMER',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 1
	},
	meta: {
		gender: 'm',
		country: 'us',
		season: 'Release',
		height: 178,
		weight: 80,
		price: {
			renown: 1000,
			r6credits: 0
		}
	},
	bio: {
		real_name: 'Jordan Trace',
		birthplace: 'Plano, U.S.A'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#d7542b"></path><path d="m235.222 195.333-18-.5-1.389-10.556-3.292-8.819L216 171.25l8.208 6.083 4.958-3.292 7.25 6.167-3.583 8.208 4.875-8.542-6.875-7.042 7.167-4.75L224.625 173l-5.167-6.333.5-.583-.708-10.292 1.792-10.333-6.931-7.653 5.361-4.917 24.5 1.75 24.583-17.583-24.638 16.444-25.194-4.611-5.681 3.542 1.431-13.181 8.597-6.5 2.75-7.708 4.583-2.056-4.931 1.833-2.986 6.903-9.174 5.882-8.007-3.785-10.861.222-5.903 3.083-4.75-7.708-12.042-4.5 5.333-7.833-7.417 8.583 12.375 5.792 3.25 7.542-9.25-.417-10.333-6.667-9.917 7.042-9.097-4.931-3.486.472-14.375-7-4.938 11.479-15.604-.229 16.062.833 5.146-10.208 10.444 5.653-5.236.639-.667 11.417 1.042 7.25-4.917 8.917-5.375-.875-3.208-10.042-15.083 1.333-8.875-10.083 8.625 10.708 14.417-.75 2.25 9.125-10.958 1.292 11.375 8.5-8.264 3.583 10.069-3.444-7.556-6.931 7.417.125 7.208 1.958 3.083-3.875.042 3 2.875 8.958.208 9.417-4.375 7.542-7.062 4.417-8.854-.375-8.123 2.792L95.208 175l14.667 5.292 8.75-2.417 8.042 1.292-1.5 8.042-13-1.917 11.583 3.792-16.417 11.583-2.125 7.167-4.167 5.417 4.792-5.208 2.375-6.583 18.583-11.958 3.458-9.958 3.875-1.5 2.708 6.833.25 9.125-4.583 9.833 4.292 9.667-2.833 5.667-6.333-2.208-10.5 11.75-19.417-3.583-16 5.333 16.069-4.319L117.729 231l10.729-10.333 3.562 2 4 10.854 13.083 3.542-11.84 11.438-8.389-7.708-11.75 13.625 11.773-12.813 8.338 8.396 14.278-12.542 5.611 1.458 10.208-2.639 12.611-.167 8.347-.944-6.146 7.917 5.5 8.062-3.625 6.354 4.229-6.562-4.667-7.896 7.896-8.562 5.375-1.083 8.146-3 5.417 3.583-13.25 12.833-5.417-1.688 5.729 3.021 16.417-12.354 8.021 4.917-7.938-17.917-.208-6.479 7.667 4.521 4.104-7.208 9 4.875-9.312-6.875-4.479 4.208-4.896-5.146 4.854-6.542-2.431-7.368 16.5-.278 11.444 5.167 4.778-2.111-4.889 1.5zm-98.75-64.916v-11.111l8.778.028zm2.153 100.271-2.111-7.312 2.25-5.167 11.014 15.264zm70.333-58.813 1.562-12.292 5.979-14.208-2 11.875 2.125 5.375zm2.542 37.833-.604-25.083 5.771 19.229z"></path><path d="m147.458 119.958 8.625 4.917 9.75-7.583 16.084 7.5 15.889-4.681 11.277-.167-1.611 15.612 6.028 7.972-4.861 12.694-3.681 15.195 4.125 6.875-2 22.166 3.875 27.459-8-5.5L182 233.458l-26.083 2-19.5-31.125 6.958-16.916-4.667-12.459 4.5-16.25-6.583-20.541z" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-thermite'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
